import React, { useState } from "react";

import { AdminLayout, useTranslation } from "@opendash/core";
import { useSearchParams } from "@opendash/router";

import { Input, Layout, Result } from "antd";
import { MIAASIframeProps } from "../types";

const { Search } = Input;
const { Content, Sider } = Layout;

export const MIAASIframe = (props: MIAASIframeProps) => {
  const t = useTranslation();
  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const url = searchParams.get("url");

  if (showError) {
    return (
      <Result
        title={t("miaas:overview.error")}
        subTitle={t("miaas:overview.errorSubtitle")}
      ></Result>
    );
  }

  return (
    <AdminLayout siderStyle={{ zIndex: 1 }}>
      <div style={{ width: "100%", height: "100%", overflow: "hidden" }}>
        <iframe
          src={decodeURI(url)}
          style={{
            width: "calc(100% + 300px)",
            height: "calc(100vh + 70px)",
            marginTop: "-70px",
            marginLeft: "-315px",
          }}
        />
      </div>
    </AdminLayout>
  );
};
export default MIAASIframe;
